import React, { useMemo, useState } from "react";
import videojs from "video.js";
import cn from "classnames";
import "video.js/dist/video-js.css";
import { enqueueSnackbar } from "notistack";
import DescriptionBasic from "../course-description/DescriptionBasic";
import DescriptionPro from "../course-description/DescriptionPro";
import TrainingSchedulePro from "./Training-schedule-pro";
import BasicTrainingSchedule from "./Training-schedule-basic";

const VideoJS = (props) => {
  const [active, setActive] = useState(undefined);
  const [tab, setTab] = useState("content");
  const [openTrainingSchedule, setOpenTrainingSchedule] = useState(false);
  const videoRef = React.useRef(null);
  const playerRef = React.useRef(null);
  const { options, onReady, playVideo, videos, training } = props;

  const sortedVideos = useMemo(() => {
    if (!videos) return [];

    return [...videos].sort((a, b) => {
      if (a.free !== b.free) {
        return a.free ? -1 : 1;
      }

      return a.sort_order - b.sort_order;
    });
  }, [videos]);

  const closeScheduleHandler = () => {
    setOpenTrainingSchedule(false);
  };

  React.useEffect(() => {
    if (!playerRef.current) {
      const videoElement = document.createElement("video-js");
      videoElement.classList.add("vjs-big-play-centered");
      videoRef.current.appendChild(videoElement);

      const player = (playerRef.current = videojs(videoElement, options, () => {
        onReady && onReady(player);
      }));
    } else {
      const player = playerRef.current;
      player.autoplay(options.autoplay);
      player.src(options.sources);
    }
  }, [options, onReady]);

  React.useEffect(() => {
    return () => {
      if (playerRef.current && !playerRef.current.isDisposed()) {
        playerRef.current.dispose();
        playerRef.current = null;
      }
    };
  }, []);

  return (
    <div className="flex flex-col lg:flex-row bg-white shadow-lg rounded-lg overflow-hidden max-w-7xl mx-auto border border-gray-200">
      {

        openTrainingSchedule && (
          <div className="fixed top-0 left-0 w-full h-full bg-white bg-opacity-90 z-50 max-h-screen overflow-auto print:static">
            {training?.title === "Basic" ? <BasicTrainingSchedule onClose={closeScheduleHandler} /> :
              <TrainingSchedulePro onClose={closeScheduleHandler} />}
          </div>
        )
      }

      <div className="w-full lg:w-3/4 sticky top-0 print:hidden">
        <div ref={videoRef} className="video-container"></div>
        <div className="w-full lg:hidden flex border-b">
          <button
            className={`w-1/2 py-3 text-center font-semibold ${tab === "content"
              ? "border-b-2 border-baseBlue text-baseBlue"
              : "text-gray-600"
              }`}
            onClick={() => {
              setTab("content");
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
          >
            Course Content
          </button>
          <button
            className={`w-1/2 py-3 text-center font-semibold ${tab === "description"
              ? "border-b-2 border-baseBlue text-baseBlue"
              : "text-gray-600"
              }`}
            onClick={() => {
              setTab("description");
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
          >
            Description
          </button>
        </div>
        {tab === "description" && (
          <div className="lg:hidden p-4">
            {training?.title === "Basic" ? (
              <DescriptionBasic />
            ) : (
              <DescriptionPro />
            )}
          </div>
        )}
        <div className="hidden lg:block p-4">
          {training?.title === "Basic" ? (
            <DescriptionBasic />
          ) : (
            <DescriptionPro />
          )}
        </div>
      </div>
      <div className="lg:w-1/4 bg-gray-50 p-6 border-t lg:border-l lg:border-t-0 border-gray-200 flex flex-col print:hidden">
        <h3 className="text-xl font-semibold text-gray-800 mb-4 hidden lg:block">
          Course Content
        </h3>
        <div className="flex-grow lg:relative">
          <div className="lg:absolute w-full lg:top-0 lg:left-0 lg:bottom-0 lg:overflow-y-auto">
            {(tab === "content" || window.innerWidth >= 1024) &&
              sortedVideos?.map((video, index) => {
                const isPlayable =
                  (video.free || !video.locked) && video.source;
                return (
                  <div
                    key={index}
                    className={cn(
                      "flex items-center justify-between cursor-pointer w-full first:rounded-t-md last:rounded-b-md text-gray-800 font-medium py-3 px-4 border-t-0 first:border-t-1 border border-gray-300 shadow-sm transition focus:outline-none focus:ring-2 focus:ring-baseBlue",
                      {
                        "opacity-50 cursor-default": !isPlayable,
                        "bg-lightBlue text-white hover:bg-darkBlue":
                          active === video.id,
                      }
                    )}
                    onClick={() => {
                      if (isPlayable) {
                        if (active === video.id) return;
                        setActive(video.id);
                        playVideo(video.source);
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      } else {
                        enqueueSnackbar(
                          "You need to purchase the course to unlock this video",
                          { variant: "info" }
                        );
                      }
                    }}
                  >
                    <div className="flex gap-2">
                      <span>{index + 1}.</span>
                      <span>{video.title}</span>
                    </div>
                  </div>
                );
              })}
            {
              (sortedVideos?.filter(video => video.source).length === sortedVideos?.length) && (
                <div
                  className={cn(
                    "flex items-center justify-center cursor-pointer w-full first:rounded-t-md last:rounded-b-md text-gray-800 font-medium py-3 px-4 border-t-0 first:border-t-1 border border-gray-300 shadow-sm transition focus:outline-none focus:ring-2 focus:ring-baseBlue",

                  )}
                  onClick={() => {
                    setOpenTrainingSchedule(true);
                  }}
                >
                  <div>Training Schedule</div>
                </div>
              )
            }

          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoJS;
